import { toast } from "react-toastify";
import {
   FETCH_ERROR,
   FETCH_START,
   FETCH_SUCCESS,
   INIT_URL,
   SHOW_MESSAGE,
   SIGNOUT_USER_SUCCESS,
   AUTH_USER_DATA,
   USER_TOKEN_SET,
} from "../constants/ActionTypes";
import { ToastErrorNotification } from "../util";
import axios from '../util/Api'

export const setInitUrl = (url) => {
   return {
      type: INIT_URL,
      payload: url
   };
};

export const getUser = () => {
   return async (dispatch) => {
      dispatch({ type: FETCH_START });
      try {
         const token = localStorage.getItem('token');
         if (token) axios.defaults.headers.common['Authorization'] = "Bearer " + token;
         const { data } = await axios.get('/accounts');
         console.log("get User res => : ", data);
         dispatch({ type: AUTH_USER_DATA, payload: data.account });
         dispatch({ type: FETCH_SUCCESS });
      } catch (err) {
         localStorage.clear();
         dispatch({ type: SIGNOUT_USER_SUCCESS });
         dispatch({ type: FETCH_ERROR, payload: "Token expired." });
         toast.success('Session expired. Please login again.');
      }
   }
};

export const userSignIn = ({ email, password, isRemember }) => {
   return async (dispatch) => {
      dispatch({ type: FETCH_START });
      axios.post('/accounts/login', { email, password, isRemember }
      ).then(({ data }) => {
         localStorage.setItem("token", data.access_token);
         if (data.access_token) axios.defaults.headers.common['Authorization'] = "Bearer " + data.access_token;
         dispatch({ type: USER_TOKEN_SET, payload: data.access_token });
         dispatch({ type: AUTH_USER_DATA, payload: data.account });
         dispatch({ type: FETCH_SUCCESS });
      }).catch((err) => {
         // if(error.response.status === 422) dispatch({ type: FETCH_ERROR, payload: "Email or password is invalid." });
         // console.log("Error****:", err.message);
         dispatch({ type: FETCH_ERROR, payload: "Error during login request." });
         if (err.response.status === 422) {
            const { errors } = err.response.data;
            if (errors) ToastErrorNotification(errors);
         }
      });
   }
};

export const userSignUp = (payload, history) => {
   const { firstName, lastName, email, password } = payload;
   return async (dispatch) => {
      dispatch({ type: FETCH_START });
      axios.post('/accounts', {
         firstName,
         lastName,
         email,
         password
      }).then(({ data }) => {
         console.log(" data === ", data)
         localStorage.setItem("token", data.access_token);
         if (data.access_token) axios.defaults.headers.common['Authorization'] = "Bearer " + data.access_token;
         console.error(" axios.defaults.headers.common  === ", axios.defaults.headers.common)
         dispatch({ type: USER_TOKEN_SET, payload: data.access_token });
         dispatch({ type: AUTH_USER_DATA, payload: data.account });
         dispatch({ type: FETCH_SUCCESS });
         history.push('/app');
      }).catch((err) => {
         dispatch({ type: FETCH_ERROR, payload: "Error duing account registeration request." });
         console.log("Error****:", err);
         console.log("err.response****:", err.response);
         console.log("err.response.data****:", err.response.data);
         if (err.response.status === 422) {
            const { errors } = err.response.data;
            if (errors) ToastErrorNotification(errors);
         }
      });
   }
};

export const userSignOut = () => {
   return (dispatch) => {
      localStorage.clear();
      dispatch({ type: SIGNOUT_USER_SUCCESS });
      // dispatch({ type: FETCH_START });
      // axios.get('/accounts/logout',
      // ).then(({ data }) => {
      //    if (data.status === "success") {
      //       localStorage.removeItem("token");
      //       dispatch({ type: FETCH_SUCCESS });
      //       dispatch({ type: SIGNOUT_USER_SUCCESS });
      //    } else {
      //       dispatch({ type: FETCH_ERROR, payload: data.error });
      //    }
      // }).catch(function (error) {
      //    dispatch({ type: FETCH_ERROR, payload: error.message });
      //    console.log("Error****:", error.message);
      // });
   }
};
export const userUpdate = ({ firstName, lastName, email, image, password }) => {
   console.log(firstName, lastName, email, image, password);
   return (dispatch) => {
      dispatch({ type: FETCH_START });
      axios.post('/accounts', { firstName, lastName, email, image, password }
      ).then(({ data }) => {
         console.log("data:", data);
         if (data.account) {
            dispatch({ type: FETCH_SUCCESS });
            dispatch({ type: USER_TOKEN_SET, payload: data.access_token });
            dispatch({ type: AUTH_USER_DATA, payload: data.account });
         } else {
            console.log("payload: data.error", data.error);
            dispatch({ type: FETCH_ERROR, payload: "Network Error" });
         }
      }).catch(function (err) {
         console.log("Error****:", err.message);
         dispatch({ type: FETCH_ERROR, payload: err.message });
         const { errors } = err.response.data;
         console.log("Error****:", err.response.data);
         dispatch({ type: FETCH_ERROR, payload: err.response.data });
         ToastErrorNotification(errors);
      });
   }
};

export const userResetPassword = (payload, ownProps) => {
   const { entoken, password } = payload;
   const { history } = ownProps;
   return (dispatch) => {
      dispatch({ type: FETCH_START });
      axios.post('/request-password', { entoken, password }
      ).then(({ data }) => {
         console.log(" USER RESET PASSWORD RES ===> ", data);
         if (data.isValid) {
            localStorage.setItem("token", data.access_token);
            if (data.access_token) axios.defaults.headers.common['Authorization'] = "Bearer " + data.access_token;
            dispatch({ type: FETCH_SUCCESS });
            dispatch({ type: USER_TOKEN_SET, payload: null });
            dispatch({ type: AUTH_USER_DATA, payload: null });
            dispatch({ type: INIT_URL, payload: '/app' });
            toast.success("Password changed");
            history.push('/login');
         } else {
            console.log(" User Reset password error ========> ", data);
            dispatch({ type: FETCH_ERROR, payload: data.message });
            history.push('/request-password/new/expired');
         }
      }).catch((err) => {
         console.log("User Reset password Error****:", err.message);
         const { errors } = err.response.data;
         console.log("Error****:", err.response.data);
         dispatch({ type: FETCH_ERROR, payload: err.response.data });
         ToastErrorNotification(errors);
      });
   }
}

export const updateAccountInfo = (payload, history) => {
   const { companyName, companyDisplayName, owner, location, timeZone, dateFormat } = payload;
   return (dispatch) => {
      dispatch({ type: FETCH_START });
      axios.put('/accounts-company', { companyName, companyDisplayName, owner, location, timeZone, dateFormat }).then(({ data }) => {
         dispatch({ type: FETCH_SUCCESS });
         history.push('/app/settings');
      }).catch(err => {
         console.log("Error****:", err.response.data);
         dispatch({ type: FETCH_ERROR, payload: err.response.data });
         toast.error('Failed to update account.');
      });
   }
}
